import { Component, Input } from '@angular/core';
import { IconComponent, IconName } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-meatball-menu-item',
	templateUrl: './meatball-menu-item.component.html',
	styleUrls: ['./meatball-menu-item.component.scss'],
	imports: [IconComponent],
})
export class MeatballMenuItemComponent {
	@Input()
	icon?: IconName;
}
